<template>
  <div class="base-user-info">
    <div class="sub-title">企业基本信息</div>
    <div class="row clearfix">
      <div class="left requisite">行业分类：</div>
      <div class="right">
        <el-select></el-select>
      </div>
    </div>
    <div class="row clearfix">
      <div class="left requisite">企业logo：</div>
      <div class="right">
        <el-select></el-select>
      </div>
    </div>

    <div class="sub-title">所属行业信息</div>
    <div class="row clearfix">
      <div class="left requisite">行业分类：</div>
      <div class="right">
        <el-select></el-select>
      </div>
    </div>
    <div class="row clearfix">
      <div class="left">行业详情：</div>
      <div class="right">
        <el-input></el-input>
      </div>
    </div>
    <div class="sub-title">联系信息</div>
    <div class="row clearfix">
      <div class="left requisite">所在地区：</div>
      <div class="right">
        <addr-three-select></addr-three-select>
      </div>
    </div>
    <div class="row clearfix">
      <div class="left">街道地址：</div>
      <div class="right">
        <el-input></el-input>
      </div>
    </div>
    <div class="row clearfix">
      <div class="left">联系电话：</div>
      <div class="right">
        <el-input></el-input>
      </div>
    </div>
    <div class="row clearfix">
      <div class="left">传真：</div>
      <div class="right">
        <el-input></el-input>
      </div>
    </div>
  </div>
</template>

<script>
  import AddrThreeSelect from '@/components/fields/AddrThreeSelect'

  export default {
    name: 'BasicInfoForm',
    components: {AddrThreeSelect},
    data() {
      return {
        addrCode: '',
      }
    },
  }
</script>

<style scoped>
  .base-user-info {
    width: 800px;
  }
  .sub-title{
    margin-top: 20px;
    font-size: 16px;
  }
  .row{
    margin-bottom: 15px;
  }

  .left {
    float: left;
    width: 130px;
    line-height: 40px;
    text-align: right;
  }

  .right{
    float: left;
    width: 300px;
    padding-left: 30px;

  }

</style>
<style>
  /*.base-user-info .el-input__inner{*/
  /*  height: 30px;*/
  /*}*/
</style>
